import { observable, action } from 'mobx'
import Api from '@api/xiu_yan/noticeApi'
import { message, Modal } from 'hljd'
import { isEmptyObj } from '@hlj/hlj-utils'

class Store {
  @observable visible = false
  @action
  showModal = val => async () => {
    let { success } = await Api.check()
    if (success) {
      this.visible = true
      this.content = val
    }
  }
  @action
  cancelModal = () => {
    this.content = ''
    this.visible = false
  }

  @observable list = []
  @observable content = ''
  @observable content_tmp = ''
  @action
  changeField = val => {
    this.content = val
  }

  @action
  getList = async () => {
    this.list = []
    let { data, success } = await Api.getNotice()
    if (!success) return
    !isEmptyObj(data) && this.list.splice(0, 1, data)
    this.content_tmp = data.content
  }

  @action
  delNotice = () => {
    Modal.confirm({
      title: '确定删除店铺公告？',
      onOk: async () => {
        let { success } = await Api.del()
        if (success) {
          this.getList()
        }
      }
    })
  }

  @action
  editNotice = async () => {
    if (this.content_tmp === this.content) {
      return message.warn('公告内容没有变化')
    }
    let { success } = await Api.edit({ content: this.content })
    if (success) {
      this.getList()
      this.visible = false
      this.content = ''
    }
  }
}

export default new Store()
